let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7Qdyn")).then(() => parcelRequire('cTdvD'));